"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const material_1 = require("@mui/material");
const StyledDrawerTitle = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    ...theme.typography.h6,
    margin: '0 0 15px 0',
    fontSize: theme.typography.pxToRem(20),
    display: 'block',
    position: 'sticky',
    inset: '0',
    zIndex: '10',
    fontWeight: theme.typography.tsFontWeight.semiBold,
    padding: '21px 20px',
    backgroundColor: theme.palette.tsGoColor.pink,
    color: theme.palette.tsGoColor.white,
    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
        ? {
            backgroundColor: 'white',
            fontSize: '14px',
            fontWeight: 400,
            color: '#000000',
            padding: '1px 20px',
            borderBottom: '1px solid hsla(0, 0%, 59%, 1)',
            margin: 0,
        }
        : {}),
}));
const DrawerAside = ({ id, title, open, onClose, hideBackdrop, footerButtons, children, width = 320, }) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Drawer, { component: "aside", "data-testid": id, id: id, open: open, anchor: 'right', sx: { width }, onClose: onClose, ModalProps: { hideBackdrop: hideBackdrop || !open }, children: [(0, jsx_runtime_1.jsx)(StyledDrawerTitle, { component: "div", children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, sx: {
                        alignItems: 'center',
                    }, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { "data-testid": "drawer-title", size: 11, children: title }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: 1, children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: onClose, children: (0, jsx_runtime_1.jsx)(Close_1.default, { "ts-variant": "closeIcon", "data-testid": "close-icon" }) }) })] }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, { style: {
                    height: '100vh',
                }, sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    justifyContent: 'space-between',
                    p: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? '10px 16px' : '10px',
                }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            flexGrow: 1,
                        }, children: children }), footerButtons ? ((0, jsx_runtime_1.jsx)(material_1.Box, { style: {
                            padding: '0 16px 20px',
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    padding: '0 0 20px',
                                }
                                : {}),
                        }, children: (0, jsx_runtime_1.jsx)(material_1.Stack, { sx: {
                                pt: 3,
                                mt: 'auto',
                                gap: 1,
                            }, children: footerButtons }) })) : null] })] }));
};
exports.default = DrawerAside;
